import api from './api'

/**
 * Favicon webu přes náš server (`/tools/favicon`) — endpoint favicon stáhne přímo
 * z cílového webu a nacachuje. Klient díky tomu nikdy nevolá Google (s2/favicons
 * vracelo 404 a je to i otázka soukromí).
 */
export const faviconUrl = (domain: string) =>
  `${api.defaults.baseURL}/tools/favicon?domain=${encodeURIComponent(
    (domain || '').replace(/^https?:\/\//, '').replace(/\/.*$/, '')
  )}`
